import { createFileRoute } from '@tanstack/react-router'
import UserProfile from '@preferences/user/UserProfile'

export const Route = createFileRoute('/_auth/profile')({
  component: RouteComponent,
})

function RouteComponent() {
  return <UserProfile />
}
